// extracted by mini-css-extract-plugin
export default {"tile":"Tile_tile__X96it","dragging":"Tile_dragging__mrAY8","used":"Tile_used__d48If","tileValue":"Tile_tileValue__VI7Gp"};